/* Delegated handlers work after Shopify Theme Editor section reloads. */
(() => {
  if (window.hhStudioLoaded) return;
  window.hhStudioLoaded = true;
  function activateTab(tab, focus = false) {
    const group = tab.closest('[role="tablist"]');
    if (!group) return;
    group.querySelectorAll('[data-hh-tab]').forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    if (focus) tab.focus();
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-hh-tab]');
    if (tab) activateTab(tab);
    const filter = event.target.closest('[data-hh-faq-filter]');
    if (filter) {
      const section = filter.closest('.hh-studio');
      const category = filter.dataset.hhFaqFilter;
      section.querySelectorAll('[data-hh-faq-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
      section.querySelectorAll('[data-hh-faq-category]').forEach(question => { question.hidden = category !== 'all' && question.dataset.hhFaqCategory !== category; });
    }
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-hh-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[data-hh-tab]')];
    let next = tabs.indexOf(tab);
    if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else next = (next + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    activateTab(tabs[next], true);
  });
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[role="tabpanel"]');
    if (panel) {
      const tab = document.getElementById(panel.getAttribute('aria-labelledby'));
      if (tab) activateTab(tab);
    }
    const question = event.target.closest('details');
    if (question) question.open = true;
  });
})();
